import React from "react";
import style from "./style.module.scss"


const UserListItem = ({ user, onSelect, loading }) => {
    if (loading) return <div className={style.skeletonUserItem} onClick={() => onSelect(user)} >
                <div className={`skeleton-loader ${style.avatar}`}></div>

        <div className={style.userInfo}>
            <div className={style.group}>
                <div className={`skeleton-loader ${style.title}`} ></div>
                <div className={`skeleton-loader ${style.description}`} ></div>
            </div>

        </div>
    </div>
    return (
        <div className={style.userItem} onClick={() =>  { if(typeof onSelect === 'function')onSelect(user)}} >
            <img className={style.avatar} src={user.avatar_url} alt={user.login} />
            <div className={style.userInfo}>
                <div>
                    <div className={style.title}>{user.login}</div>
                    <div className={style.description}>Github User</div>
                </div>

            </div>
        </div>
    );
}
export default UserListItem;